import { Component } from '@angular/core';
import { Router, NavigationEnd} from "@angular/router";

@Component({
  selector: 'app-disclaimer-component',
  templateUrl: './discalimer.html',
  standalone: true
})

export class DisclaimerComponent {
  public isVisible: boolean = true;

  constructor(private router: Router) {
    router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.isVisible = true;
      }
    })
  }
}
